var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.matchStatus === 'FULL FIT')?_c('FullFit'):(_vm.matchStatus === 'NO FIT')?_c('NoFit'):_c('Raw')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }